import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { StorefrontListingCard } from '../../components/cards/StorefrontListingCard';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { COLUMN_WIDTH, GAP_TOKEN } from './ResultsGridWithSummary';
import { useAppContext } from '../../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGridWithoutSummary() {
  var _data$result$cards, _params$get;
  const appContext = useAppContext();
  const {
    collectionId,
    collectionSlug,
    data,
    queryType
  } = useSearchResultsQuery();
  const cards = (_data$result$cards = data === null || data === void 0 ? void 0 : data.result.cards) !== null && _data$result$cards !== void 0 ? _data$result$cards : [];
  const params = useSearchParams();
  const pageNumber = parseInt((_params$get = params.get('page')) !== null && _params$get !== void 0 ? _params$get : '1', 10);
  const searchTerm = params.get('search');
  return /*#__PURE__*/_jsx(CardGrid, {
    columnSize: COLUMN_WIDTH,
    gap: GAP_TOKEN
    // prevents a lone card from being too wide
    ,
    maxInlineSize: cards.length === 1 ? `${COLUMN_WIDTH}px` : undefined,
    children: cards.map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
      collectionId: collectionId,
      collectionSlug: collectionSlug,
      listing: card,
      pageNumber: pageNumber,
      queryType: queryType,
      resultCount: cards.length,
      resultIndex: index + 1,
      searchTerm: searchTerm,
      appContext: appContext
    }, card.listingId))
  });
}